/**
 * Arbitrary user-by-id lookups against platform-api `GET /users/:userId`.
 * TanStack Query dedupes by `queryKey`, so concurrent callers share one fetch.
 */
import { queryOptions } from '@tanstack/react-query';
import type { UserResponseDto } from '@monksflow/platform-api-sdk/dist/generated';

import { PlatformApi } from '@/lib/api/platform/platformSdk';

export const USER_DIRECTORY_QUERY_KEYS = {
  all: ['user-directory'] as const,
  byId: (userId: string) => [...USER_DIRECTORY_QUERY_KEYS.all, 'by-id', userId] as const,
} as const;

const getUserById = async (userId: string): Promise<UserResponseDto> => {
  const response = await PlatformApi.platformApi.get<UserResponseDto>(`/users/${userId}`);
  return response.data;
};

/** `staleTime: 5min` — display info (name, avatar) changes rarely. */
export const userByIdQueryOptions = (userId: string | null | undefined) =>
  queryOptions({
    queryKey: USER_DIRECTORY_QUERY_KEYS.byId(userId ?? ''),
    queryFn: () => getUserById(userId!),
    enabled: !!userId,
    staleTime: 5 * 60_000,
  });
